export default function (baseString: string, count: number): string {
    return `${baseString} (${count})`;
}
